export default (urlParameters) => {
  jweather.markersByProvider = {
    0: { colorAlias: 'nc-blue' },
    1: { colorAlias: 'yellow' },
    1370: { colorAlias: 'aib-orange' },
    1047: { colorAlias: 'sw-green' },
    1653: { colorAlias: 'sw-green' }
  }
}
